import { cityCountrySchema } from "@/lib/schemas/cityCountry";
import { z } from "astro/zod";
import { unsplashImageDataSchema } from "./unsplash";

export const blogSchema = z.object({
  title: z.string(),
  content: z.string(), // md
  slug: z.string(),
  info: cityCountrySchema,
  createdAt: z.string(), // iso date
  unsplashImageData: unsplashImageDataSchema.optional().nullable(),
});

export type BlogSchema = z.infer<typeof blogSchema>;
